import { memo } from 'react'
import ReactJson from 'react-json-view'

import { DATETIME_FULL, formatTimeFromSQL } from 'app/utils/formatDate'
import { STATES_TYPES } from '../../consts'
import { ReactJsonContainer } from './styles'

interface HomeSystemStateValueProps {
  value: string | number | boolean | object
  type: string
}

function HomeSystemStateValue({ value, type }: HomeSystemStateValueProps) {
  switch (type) {
    case STATES_TYPES.OBJECT:
      try {
        const parsedJson = JSON.parse(value as string)
        const jsonName = `${((value as string) || '').substring(0, 210)}...`

        return (
          <ReactJsonContainer>
            <ReactJson
              defaultValue={{}}
              src={parsedJson}
              name={jsonName}
              displayDataTypes={false}
              displayObjectSize={false}
              collapsed={true}
              indentWidth={2}
              collapseStringsAfterLength={12}
              enableClipboard={true}
            />
          </ReactJsonContainer>
        )
      } catch (e) {
        return <>{`${value}`}</>
      }
    case STATES_TYPES.DATE_TIME:
      return <>{formatTimeFromSQL(value as string, DATETIME_FULL)}</>
    default:
      return <>{`${value}`}</>
  }
}

export default memo(HomeSystemStateValue)
